export const platformVersion = '^20.0.0';
